import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { required } from '../../../utils/validations';
import { AlertService } from '../../../services/alert.service';
import { FormattedMessage } from 'react-intl';
import { Select } from '../../common/select.component';
import { useSuppliers } from '../../../api/suppliers';
import useSWRMutation from 'swr/mutation';
import { trpc, RouterInput } from '../../../api/trpc';

type Props = {
  close: () => void;
  reject: () => void;
  orderId: string;
};

type Form = {
  supplierId: string;
};

export const AdminCreateCustomsOrderFromSampleModal: React.FC<Props> = ({
  orderId,
  ...props
}) => {
  const { data: suppliers } = useSuppliers();
  const { trigger: createOrder } = useSWRMutation(
    ['customsDelivery.createOrderFromSample'],
    (
      _k,
      { arg }: { arg: RouterInput['customsDelivery']['createOrderFromSample'] },
    ) => trpc.customsDelivery.createOrderFromSample.mutate(arg),
  );
  const {
    formState: { errors, isSubmitting },
    handleSubmit,
    control,
  } = useForm<Form>();

  const onSubmit = handleSubmit(async (data) => {
    await createOrder({ orderId: orderId, supplierId: +data.supplierId });
    AlertService.success();
    props.close();
  });

  return (
    <div className="modal-dialog">
      <form className="modal-content" onSubmit={onSubmit}>
        <div className="modal-header border-bottom-0 p-4">
          <h3 className="text-center">Выберите поставщика ВЭД</h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              props.reject();
            }}
          />
        </div>

        <div className="modal-body pt-2 p-4">
          <Controller
            name="supplierId"
            control={control}
            rules={required}
            render={({ field }) => (
              <Select
                className="mb-3"
                title="Поставщик"
                placeholder="Выберите поставщика"
                options={
                  suppliers
                    ?.filter(({ location }) => location?.isCustomsDelivery)
                    .map(({ id, name, location }) => ({
                      value: id,
                      label:
                        name +
                        (location?.name ? ` (откуда: ${location.name})` : ''),
                    })) ?? []
                }
                {...field}
                error={errors.supplierId?.message}
              />
            )}
          />
        </div>
        <div className="modal-footer justify-content-end">
          <button
            type="submit"
            className="btn btn-success"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <FormattedMessage
                defaultMessage="Создать"
                id="AdminCreateCustomsOrderFromSampleModal.status-label.submit"
                description="Надпись на кнопке"
              />
            )}
          </button>
        </div>
      </form>
    </div>
  );
};
